import { render, staticRenderFns } from "./DocumentRow.vue?vue&type=template&id=7545f706"
import script from "./DocumentRow.vue?vue&type=script&lang=ts"
export * from "./DocumentRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports